import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

const muiCheckboxStyles: Components<Theme> = {
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: 0,
        '&.Mui-checked': {
          borderColor: 'var(--primary)'
        },
        '&.Mui-checked .MuiSvgIcon-root': {
          color: 'var(--primary)',
          fill: 'var(--white)'
        },
        '&.primary-checkbox.Mui-checked .MuiSvgIcon-root': {
          color: 'var(--white)',
          fill: 'var(--primary)'
        }
      }
    }
  }
};

export default muiCheckboxStyles;
